// extracted by mini-css-extract-plugin
export default {"card_error__wrapper":"error_card_error__wrapper__sQS3w"};